export default "__VITE_ASSET__DYH$4uD9__"